import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestTypes, getTypes } from '../../../bundles/types';
import { requestTags, getTags } from '../../../bundles/tags';
import { getFilesPanelAdminSchema } from '../../panels/FilesPanel';
import JSONEditor from '../../JSONEditor';

const FilesSettings = ({ settings, site: { id: siteId }, onSave, onFullSettings, onClose }) => {
  const dispatch = useDispatch();
  const types = useSelector(getTypes);
  const tags = useSelector(getTags);

  useEffect(() => {
    dispatch(requestTypes(siteId));
    dispatch(requestTags(siteId));
  }, []);

  const schema = useMemo(() => getFilesPanelAdminSchema(types || [], tags || []), [types, tags]);

  return (
    <div className="column-content">
      <JSONEditor
        title="Files: Options"
        schema={schema}
        formData={settings}
        onFormSubmit={onSave}
        onSecondaryAction={onFullSettings}
        cancelCallback={onClose}
        saveButtonText={'Save'}
        initialEditMode
        showEditButton={false}
      />
    </div>
  );
};

export default FilesSettings;
